import messages from './cmsPreview.json' with { type: 'json' };

export const cmsPreviewEn: Readonly<typeof messages> = messages;
